<div class="loginHeader fixed-top bg-primary">&nbsp;</div>
<div class="d-flex flex-wrap align-items-center justify-content-start loginContainer w-100">
  <div class="loginFormContainerWrapper text-center">
    <section class="loginFormContainer mx-auto">
      <img id="primaryLogo" src="assets/img/logo.svg" alt="My ZB Portal" class="mx-auto d-block loginImage">
      <h1 id="subTitle" class="subLogo mvBoli text-center">for teachers and school administrators</h1>
      @if (errors.length > 0) {
        <div id="oauth2Errors"  class="alert alert-danger mx-auto" role="alert">
          @for (error of errors; track $index; let i = $index) {
            <div class="text-center" id="error{{i}}">{{ error }}</div>
          }
        </div>
      }
      @if (completed && isClever) {
        <nav class="text-center">
          <a id="returnToCleverLink" class="fw-bold" href="https://clever.com/login">Return to Provider</a>
        </nav>
      }
      @if (!completed) {
        <aside class="text-center">Please wait...</aside>
      }
    </section>
  </div>
  <div class="loginSwirlContainer mt-auto ms-auto align-self-end text-end">
    <img id="swirlImage" class="loginImage loginImageSwirl" src="assets/img/zb_greyswirl_right.png" role="presentation" alt="">
  </div>
</div>
<zbp-footer></zbp-footer>
